import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_SHARE_VISUALS = createFcmDetails('starfish_share_visuals', {
	owner: 'starfish',
	context: 'Petition share visuals',
	description: `
		Feature release flag that enables share visuals for petitions.
		The petition service only uses the "enabled" value for determining whether to start creating share visuals for petitions,
		while the frontend uses both "enabled" and the users "locale" to determine whether to show the UI.
	`,
	template: { enabled: true, locales: ['en-US'] },
	import: false,
});
